<template>
  <span>
    <v-icon @click.stop="dialogClicked()">delete</v-icon>

    <v-dialog v-model="dialog" width="500">
      <v-card class="rounded-lg">
        <v-card-title color="white" primary-title>
          <v-icon color="primary">delete</v-icon>
          <span class="primary--text text--darken-3 title pl-2"
            >Remove Study Dataset Variable?</span
          >
        </v-card-title>

        <v-card-text class="primary primary--text text--lighten-5 pt-4">
          Are you sure you want to delete the variable <br />
          '{{ variable.label }}' from the Study Dataset? Doing so may change the
          composition of any existing study groups and may also invalidate
          previously-run analyses.
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dialog = false">
            <v-icon left>close</v-icon> Cancel
          </v-btn>
          <v-btn color="error" @click="onDeleteVariable">
            <v-icon left>delete</v-icon> Remove Variable</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import axios from 'axios';
import { state } from '@/store/modules/cohortManager/types';
import { mapState } from 'vuex';

export default {
  props: {
    variable: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    valid: true,
    dialog: false,
  }),
  computed: {
    ...mapState('cohortManager', {
      collection: state.COLLECTION,
    }),
  },
  methods: {
    async onDeleteVariable() {
      let which = 'flip_axis' in this.variable ? 'observation' : 'subject';
      try {
        await axios.delete(
          `/api/collections/${this.collection.id}/${which}_variables/${
            this.variable.id
          }`
        );
        this.$emit('variableDeleted', true);
        this.dialog = false;
      } catch (err) {
        //        console.log('delete variable failed, err=' + err);
      }
    },
    dialogClicked() {
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style lang="scss" scoped></style>
